import { Component, OnInit, NgZone } from '@angular/core';
import { MapService } from '@app/shared/services/map.service';
import { StationsService } from '@app/shared/services/stations.service';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import * as moment from 'moment';

const FILTER_ALL = 0;
const FILTER_STATIONS = 1;
const FILTER_ALERTS = 2;

@Component({
  selector: 'app-dashboard-map',
  templateUrl: './dashboard-map.component.html',
  styleUrls: ['./dashboard-map.component.scss']
})
export class DashboardMapComponent implements OnInit {

  public today: string = moment().format();
  public filter: number = FILTER_ALL;
  public loading: boolean = true;

  public stations: Array<any> = [];
  public alerts: Array<any> = [];

  public vehicleSearch: string = '';
  public vehicleSelected: any = {};
  public vehicleOptions: any = [];
  public vehicleDisplay: boolean = false;
  public vehicleNoResult: boolean = false;
  public vehicleLoading: boolean = false;
  public _timeout: any = null;

  constructor(
    private stationService: StationsService,
    private vehicleService: VehiclesService,
    private mapService: MapService,
    private lc: NgZone
  ) { }

  changeFilter(filter): void {
    if (this.filter === filter) {
      return;
    }
    this.loading = true;
    switch (filter) {
      case FILTER_ALERTS:
        this.remove('station');
        if (this.filter === FILTER_ALL)
          break;
        this.addAlertMarkers();
        break;
      case FILTER_STATIONS:
        this.remove('alert');
        if (this.filter === FILTER_ALL)
          break;
        this.addStationMarkers();
        break;
      case FILTER_ALL:
        if (this.filter === FILTER_STATIONS)
          this.addAlertMarkers();
        if (this.filter === FILTER_ALERTS)
          this.addStationMarkers();
        break;
    }
    this.filter = filter;
    this.loading = false;
  }

  getStations(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.stationService.getStations().then((stations) => {
        this.stations = stations;
        resolve(stations);
      });
    });
  }

  addStationMarkers(): void {
    this.stations.map((station) => {
      var marker = this.mapService.addMarker([station.latitude, station.longitude], { type: "station" });

      marker.bindPopup(`
        <div class="vop-map-popup">
          <a class="vop-map-popup__station" href="/#/ressource/station/informations/${station.id}">${station.name}</a>
          <a class="vop-map-popup__society" href="/#/user/society/informations/${station.idSocietyVop}">${station.societyName} (${station.codeSociety})</a>
          <div class="vop-map-popup__vehicles">
            <img src="/assets/icons/Vehicle.svg" width="15" height="15" alt="">
            <span>${station.vehiclesAvailable} / ${station.vehiclesTotal}</span>
          </div>
        </div>
      `);
      return station;
    });
  }

  getAlerts(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.alerts = [];
      resolve([]);
    });
  }

  addAlertMarkers(): void {

  }

  addVehicleMarker(): void {
    var marker = this.mapService.addMarker(
      [this.vehicleSelected.latitude, this.vehicleSelected.longitude],
      { icon: "vehicle", type: "vehicle" }
    );

    marker.setZIndexOffset(1000);
    marker.bindPopup(`<span class="title">${this.vehicleSelected.name}</span>`);
  }

  remove(type): void {
    this.mapService.markers.map((marker) => {
      if (marker.options.type === type) {
        this.mapService.removeMarker(marker._leaflet_id);
      }
    });
  }

  ngOnInit(): void {
    this.mapService.initMap('map', [43.6, 3.8833], 16).then(() => {
      this.getStations().then(() => {
        this.addStationMarkers();
        this.getAlerts().then(() => {
          this.addAlertMarkers();
          this.mapService.resetView();
          this.loading = false;
        });
      });
    });

    this.mapService.map.scrollWheelZoom.enable();
  }

  updateVehicleOptionList(event) {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.lc.run(() => {
        this.vehicleSearch = event;
        this.vehicleLoading = true;
        this.vehicleNoResult = false;
        this.vehicleService.updateVehicles(1, this.vehicleSearch).then((res) => {
          if (res.length > 0) {
            this.vehicleOptions = res;
          } else {
            this.vehicleNoResult = true;
          }
          this.vehicleLoading = false;
        });
      });
    }, 1000);
  }

  setVehicleSearch(option) {
    this.vehicleSearch = option.name;
    this.vehicleSelected = option;
    this.remove('vehicle');
    this.addVehicleMarker();
    this.mapService.flyTo({
      latitude: this.vehicleSelected.latitude,
      longitude: this.vehicleSelected.longitude,
      zoom: 15
    })
  }

  toggleSuggestions(shouldDisplay) {
    setTimeout(() => {
      this.vehicleDisplay = shouldDisplay;
    }, 250);
  }

}
